export default __webpack_public_path__ + "static/media/soyl_social_1.a55fe00a.jpg";